export default __webpack_public_path__ + "static/mobile-33c631db4f8ac93fd9641dff64bec4b4.svg";